<template>
    <label
        class="el-radio"
        :class="[
            { 'is-disabled': isDisabled },
            { 'is-focus': focus },
            { 'is-checked': model === label },
        ]"
        role="radio"
        :aria-checked="model === label"
        :aria-disabled="isDisabled"
        :tabindex="tabIndex"
        @keydown.space.stop.prevent="model = isDisabled ? model : label"
    >
        <div class="radio-wrap">
            <span
                class="el-radio__input"
                :class="{
                    'is-disabled': isDisabled,
                    'is-checked': model === label,
                }"
            >
                <span class="el-radio__inner"></span>
                <input
                    ref="radio"
                    class="el-radio__original"
                    :value="label"
                    type="radio"
                    aria-hidden="true"
                    v-model="model"
                    @focus="focus = true"
                    @blur="focus = false"
                    @change="handleChange"
                    :name="name"
                    :disabled="isDisabled"
                    tabindex="-1"
                    autocomplete="off"
                />
            </span>
            <span class="el-radio__label" @keydown.stop>
                <slot></slot>
                <template v-if="!$slots.default">{{ label }}</template>
            </span>
        </div>
    </label>
</template>
  <script>
import Emitter from "@/mixins/emitter.js";

export default {
    name: "TsaRadio",

    mixins: [Emitter],

    inject: {
        tsaForm: {
            default: "",
        },

        tsaFormItem: {
            default: "",
        },
    },

    componentName: "TsaRadio",

    props: {
        value: {},
        label: {},
        disabled: Boolean,
        name: String,
        border: Boolean,
        size: String,
    },

    data() {
        return {
            focus: false,
        };
    },
    computed: {
        isGroup() {
            let parent = this.$parent;
            while (parent) {
                if (parent.$options.componentName !== "TsaRadioGroup") {
                    parent = parent.$parent;
                } else {
                    this._radioGroup = parent;
                    return true;
                }
            }
            return false;
        },
        model: {
            get() {
                return this.isGroup ? this._radioGroup.value : this.value;
            },
            set(val) {
                if (this.isGroup) {
                    this.dispatch("TsaRadioGroup", "input", [val]);
                } else {
                    this.$emit("input", val);
                }
                this.$refs.radio &&
                    (this.$refs.radio.checked = this.model === this.label);
            },
        },
        isDisabled() {
            return this.isGroup
                ? this._radioGroup.disabled ||
                      this.disabled ||
                      (this.elForm || {}).disabled
                : this.disabled || (this.elForm || {}).disabled;
        },
        tabIndex() {
            return this.isDisabled ||
                (this.isGroup && this.model !== this.label)
                ? -1
                : 0;
        },
    },

    methods: {
        handleChange() {
            this.$nextTick(() => {
                this.$emit("change", this.model);
                this.isGroup &&
                    this.dispatch("TsaRadioGroup", "handleChange", this.model);
            });
        },
    },
};
</script>
<style scoped lang='less'>
.el-radio{
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
    outline: none;
    margin-right: 25PX;
    user-select:none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    margin-bottom: 12PX;
    .radio-wrap{
        display: flex;
        align-items: center;
        .el-radio__input {
            white-space: nowrap;
            cursor: pointer;
            outline: none;
            display: flex;
            align-items: center;
            .el-radio__inner {
                border: 1PX solid #999999;
                border-radius: 100%;
                width: 18PX;
                height: 18PX;
                background-color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                box-sizing: border-box;
                img{
                    display: none;
                }
            }
            .el-radio__original {
                opacity: 0;
                outline: none;
                position: absolute;
                z-index: -1;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: 0;
            }
        }
        .is-checked{
            .el-radio__inner{
                background-color: #7FDC68;
                border-color: #7FDC68;
                background-image: url(./checked-icon.png);
                background-position: center;
                background-repeat:no-repeat;
                background-size: 16PX 16PX;
                &::after {
                    display: none;
                }
            }
        }
        .el-radio__label {
            font-size: 14PX;
            padding-left: 6PX;
            color:#999;
        }
    }
    
    
}
@media screen and (max-width: 750px) {
    .el-radio{
        display: block;
        margin-right: 2px;
        margin-bottom: 8px;
        .radio-wrap{
            .el-radio__input {
                .el-radio__inner {
                    width: 20px;
                    height: 20px;
                }
            }
            .is-checked{
                .el-radio__inner{
                    background-size: 15px 15px;
                    &::after {
                        display: none;
                    }
                }
            }
            .el-radio__label {
                font-size: 14px;
                padding-left: 4px;
            }
        }
        
        
    }
}
</style>
  